<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="clientes-view">
      <div style="background-color: #f9f9f9 !important;">
        <div class="page-title" style="background-color: #000;">
          <div class="auto-container">
            <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
          </div>
        </div>
        <div class="page-text" v-if="(item.subtitulo != null && fc_removeHTML(item.subtitulo).trim() !== '')">
          <div class="auto-container">
            <div class="text-subtitulo w-full" v-html="item.subtitulo"></div>
          </div>
        </div>
        <div :class="'clientes w-full ' + (item.subtitulo != null && fc_removeHTML(item.subtitulo).trim() !== '' ? 'pt-0' : '')" v-if="(clientes.loaded && clientes.list.length > 0)">
          <div class="outer-container">
            <div class="clientes-list">
              <div class="flex flex-wrap">
                <ListItemCliente v-for="(forItem, forIndex) in clientes.list" :key="forIndex" :item="forItem" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Avaliacoes -->
      <div class="clientes-avaliacoes">
        <div class="auto-container">
          <div class="title-group text-center">
            <span class="sectionTitle" v-html="fc_getText(null, 'testemunhos')"></span>
            <div class="subtitulo" v-html="fc_getText(null, 'feedback')"></div>
          </div>
          <div class="avaliacoes-galeria">
            <Galleria :value="item.avaliacoes" :circular="true" :showThumbnails="false" :showIndicators="true" :autoPlay="true" :transitionInterval="7000">
              <template #item="slotProps">
                <div class="avaliacao-block">
                  <div class="auto-container">
                    <div class="inner-box flex flex-wrap">
                      <div class="avaliacao-clienteImagem w-full sm:w-4 md:w-3">
                        <div class="imagem-box mx-auto md:ml-auto md:mr-0">
                          <img :src="slotProps.item.clienteImagem" alt="">
                        </div>
                      </div>
                      <div class="w-full sm:w-8 md:w-9 mt-2 md:mt-0 pl-4 pr-2">
                        <div class="avaliacao-citacao" v-html="slotProps.item.descricao"></div>
                        <div class="info">
                          <div class="avaliacao-clienteAutor" v-html="slotProps.item.autor"></div>
                          <span class="avaliacao-cliente" v-html="fc_removeHTML(slotProps.item.clienteDesc)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </Galleria>
          </div>
        </div>
      </div>
      <BannerContactos tipo="2" />
    </div>
  </div>
</template>

<script>
import Galleria from 'primevue/galleria';
import ListItemCliente from '@/components/ListItemCliente.vue';
import BannerContactos from '@/components/BannerContactos.vue';

export default {
  components: {
    Galleria,
    ListItemCliente,
    BannerContactos
  },
  data() {
    return {
      loaded: false,
      item: {},
      clientes: {
        loaded: false,
        list: []
      },
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.mt_loadData();
    },
    mt_loadData() {
      this.fc_fetch({ endpoint: 'Clientes/', method: 'GET', success: this.mt_loadData_success, error: () => { this.fc_goRoute('home'); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.list != null) {
        this.clientes.list = response.list;
      }
      this.clientes.loaded = true;
      this.loaded = true;
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'ClientesPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
.clientes-view .subtitulo {
  position: relative;
  color: #3c4858;
  font-size: 30px;
  line-height: 40px;
  font-weight: 500;
}
@media only screen and (max-width: 599px) {
  .clientes-view .subtitulo {
    font-size: 24px;
    line-height: 1.3em;
  }
}
.clientes {
  padding-bottom: 65px;
}
.clientes {
  position: relative;
  padding: 90px 0 70px;
}
.clientes-list {
  margin-right: -15px;
  margin-left: -15px;
}
.clientes-avaliacoes {
  position: relative;
  padding: 75px 0 75px;
}
.clientes-avaliacoes:before {
  position: absolute;
  right: 0;
  bottom: 170px;
  height: 620px;
  width: 427px;
  content: "";
  background-image: url('@/assets/icons/bg-11.png');
  background-repeat: no-repeat;
  z-index: -1;
}
.clientes-avaliacoes .sectionTitle {
  padding-left: 0;
}
.clientes-avaliacoes .sectionTitle::before {
  content: '';
  display: none;
}
.avaliacao-clienteImagem .imagem-box {
  height: auto;
  max-width: 250px;
}
.avaliacao-clienteImagem img {
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.avaliacao-clienteAutor {
  display: block;
  font-size: 17px;
  line-height: 21px;
  color: #141414;
  font-weight: 500;
}

</style>
